export default `
mutation MarkAsProcessed(
  $responseKeys: [ResponseKey!]!, 
  $dailyActivityReportIds: [ID!]!, 
  $incidentReportIds: [ID!]!
) {
  markAsProcessed(
    responseKeys: $responseKeys, 
    dailyActivityReportIds: $dailyActivityReportIds, 
    incidentReportIds: $incidentReportIds
  ) {
    void
  }
}
`;
